import type { ReactNode } from "react";
import { EXPORT_WIDTH } from "src/helpers/widgetExport";

// Fixed-width card chrome for off-screen image/PDF export. Rendering the widget
// inside this at EXPORT_WIDTH (rather than snapshotting the live tile) is what
// makes the download crisp and full-size no matter how small the tile is.
export default function WidgetExportCard({
  title,
  children,
}: {
  title?: string;
  children: ReactNode;
}) {
  return (
    <div
      style={{
        width: EXPORT_WIDTH,
        boxSizing: "border-box",
        padding: "24px 28px",
        background: "#ffffff",
        fontFamily: "inherit",
        color: "#0f172a",
      }}
    >
      {title ? (
        <div
          style={{
            fontSize: 19,
            fontWeight: 700,
            letterSpacing: "-0.01em",
            marginBottom: 16,
          }}
        >
          {title}
        </div>
      ) : null}
      {children}
    </div>
  );
}
